import { c as _c } from "react/compiler-runtime";
import type { transformCreditCardsMultiCompareEntity } from '@cc-shopping/structured-content-renderer/hydration/CreditCardsMultiCompare/transform';
import { InfoTooltip } from '@cc-shopping/ui/composites/InfoTooltip';
import { theme } from '@cc-shopping/ui/theme';
import { Box, Link, Typography } from '@mui/material';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
import { Rating } from 'src/features/product-card/NerdWalletRating/Rating';
import { SmallQuestionMark } from './DriverCard';
type MiniProductCardRatingProps = {
  offer: ReturnType<typeof transformCreditCardsMultiCompareEntity>;
  blockCTAClick: boolean;
};
export const CreditCardsMultiCompareRating = t0 => {
  const $ = _c(13);
  const {
    offer,
    blockCTAClick
  } = t0;
  if (!offer.starRating) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginBottom: "3px",
      marginTop: "1px",
      marginRight: "2px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== offer.starRating) {
    t2 = <Rating value={offer.starRating} size="19px" gap="6px" additionalStyles={t1} />;
    $[1] = offer.starRating;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== blockCTAClick || $[4] !== offer.ctaAnalytics || $[5] !== offer.reviewLink) {
    t3 = !blockCTAClick && offer.reviewLink ? <CtaLink Component={Link} href={offer.reviewLink} target="_blank" sx={{
      position: "relative",
      fontSize: ".75rem",
      marginRight: ".2rem"
    }} analytics={offer.ctaAnalytics} parameterActions={[]} skipShoppingFinishedEvent={true}>NerdWallet Rating</CtaLink> : <Typography sx={{
      fontSize: "13px",
      color: theme.palette.neutral.darker
    }}>NerdWallet Rating</Typography>;
    $[3] = blockCTAClick;
    $[4] = offer.ctaAnalytics;
    $[5] = offer.reviewLink;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <InfoTooltip text={"NerdWallet's ratings are determined by our editorial team. The scoring formula takes into\n      account the type of card being reviewed (such as cash back, travel or balance transfer) and\n      the card's rates, fees, rewards and other features."} ariaLabel="Rating Details" trigger={<SmallQuestionMark />} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <Box display="flex" alignItems="center" justifyContent="center" whiteSpace="nowrap">{t3}{t4}</Box>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <Box display="flex"><Box display="flex" flexDirection="column" alignItems="center">{t2}{t5}</Box></Box>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};